export default "__VITE_ASSET__758e0999__"